import React, { forwardRef } from "react";
import multiSelectGoldenDropdown from "./MultiSelectGoldenDropdown";
import OverflowingText from "../OverflowingText/OverflowingText";

const DropdownWithOptions = forwardRef(
  (
    {
      OPTIONS,
      isOpen,
      activeIndex,
      showArrow,
      headingValue,
      allData,
      setHeadingValue,
      position,
      handleListboxKeyDown,
      accessibilityValues,
      popupClassName = {
        open: "",
        close: "",
        wrapperClass: "",
        containerClass: "",
        popupMenuClass: "",
      },
    },
    ref,
  ) => {
    return (
      <div
        id={accessibilityValues.ariaControls} //"asset-listbox"
        ref={ref}
        role={accessibilityValues.ariaHaspopup} // listbox
        tabIndex={0}
        aria-multiselectable="true"
        aria-label={accessibilityValues.ariaLabel} //"Asset Class Filters"
        aria-activedescendant={`option-${activeIndex}`}
        onKeyDown={handleListboxKeyDown}
        className={`popup_menu checkbox-menu ${popupClassName.popupMenuClass || ""}  ${
          showArrow === false ? "no_arrow" : ""
        } ${isOpen ? "popup_menu_open" : "popup_menu_close"}`}
        style={{ ...position }}
      >
        <div className="portfolio_report_accounts_container">
          {OPTIONS.map((accountData, index) => {
            const checked =
              accountData.id === "All"
                ? headingValue === "All" ||
                  allData
                    ?.map((assetClass) => headingValue?.includes(assetClass.id))
                    ?.every(Boolean)
                : headingValue === "All" ||
                    headingValue.includes(accountData.id)
                  ? true
                  : false;
            const active = activeIndex === index;

            const valueToSet = accountData.id;

            return (
              <div
                key={accountData.id}
                id={`option-${index}`}
                role="option"
                aria-selected={active}
                aria-label={`${accountData.name}, checkbox ${
                  checked ? "checked" : "not checked"
                }`}
                onClick={() => setHeadingValue(valueToSet)}
                className={`account_listitem cursor ${active ? " active-list-item" : ""}`}
              >
                <span aria-hidden="true"></span>
                <div className="each_checkbox_wrapper">
                  <input
                    aria-hidden={true}
                    checked={checked}
                    type="checkbox"
                    className="checkbox"
                  />
                  <label
                    className="checkbox_label cursor"
                    htmlFor={accountData.id}
                    style={{ display: "contents" }}
                  >
                    <OverflowingText
                      text={
                        accountData?.name
                          ? `${accountData?.name
                              .charAt(0)
                              .toUpperCase()}${accountData?.name
                              .slice(1)
                              .toLowerCase()}`
                          : accountData?.name
                      }
                      width={140}
                      textClassName="radio_btn_label cursor_imp"
                      tooltipOnHover={true}
                      position="left"
                      tooltipClassName={
                        index === 0
                          ? "asset_class_tooltip_styles_bottom"
                          : "asset_class_tooltip_styles"
                      }
                    />
                  </label>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    );
  },
);

export default multiSelectGoldenDropdown(DropdownWithOptions);
